
// hooks/useScrollToSection.ts
import { useRef, useCallback } from 'react';

interface ScrollToSectionOptions {
    behavior?: 'smooth' | 'instant' | 'auto';
    block?: 'start' | 'center' | 'end' | 'nearest';
    inline?: 'start' | 'center' | 'end' | 'nearest';
    offset?: number;
}

export const useScrollToSection = <T extends HTMLElement = HTMLDivElement>(
    options: ScrollToSectionOptions = {}
) => {
    const ref = useRef<T>(null);

    const scrollTo = useCallback(() => {
        if (ref.current) {
            const { behavior = 'smooth', block = 'start', inline = 'nearest', offset = 0 } = options;

            if (offset !== 0) {
                const elementTop = ref.current.offsetTop;
                const offsetPosition = elementTop - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior,
                });
            } else {
                ref.current.scrollIntoView({
                    behavior,
                    block,
                    inline,
                });
            }
        }
    }, [options]);

    return { ref, scrollTo };
};
